module.exports = __webpack_public_path__ + "static/media/arrow.8b69ac60.svg";